import React from 'react';
import { useUserContext } from 'providers/UserProvider';
import HomeRedirector from '../components/common/HomeRedirector';

const AdminGuardRoute = ({ element }) => {
  const { user, selectedWarehouse } = useUserContext();
  // superuser, admin, 또는 현재 웨어하우스의 manager 허용
  if (user?.is_superuser || user?.is_admin || selectedWarehouse?.is_manager) {
    return element;
  }

  // 권한 없으면 홈으로 리디렉션
  return <HomeRedirector />;
};
export default AdminGuardRoute;
